import Typography from '@mui/material/Typography';
import { QueryFilters } from '@tanstack/react-query';
import formatDistance from 'date-fns/formatDistance';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLatestDataUpdatedAt } from 'src/common/hooks/useLatestDataUpdatedAt';

const updateFrequencyMs = 1000;

type LocationsLastRefreshProps = {
  dataTestId: string;
  type?: QueryFilters['type'];
  predicate: QueryFilters['predicate'];
};

export const LocationsLastRefresh: FC<LocationsLastRefreshProps> = (props) => {
  const { dataTestId, type, predicate } = props;
  const { t } = useTranslation();

  const [now, setNow] = useState(new Date());

  useEffect(() => {
    // Set interval to recalculate ago time
    const interval = setInterval(() => {
      setNow(new Date());
    }, updateFrequencyMs);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const lastLocationsQueryUpdated = useLatestDataUpdatedAt({
    type,
    predicate,
  });

  if (lastLocationsQueryUpdated === 0) {
    return null;
  }

  const difference = lastLocationsQueryUpdated - now.getTime();

  const agoText =
    difference < 0
      ? formatDistance(lastLocationsQueryUpdated, now, { addSuffix: true })
      : formatDistance(0, 10, { addSuffix: true });

  return (
    <Typography data-testid={dataTestId} variant="text1" textAlign="end">
      {t('locations.filters.lastRefreshed')}: {agoText}
    </Typography>
  );
};
